import SectionCard from "@/components/base/SectionCard";
import type { TopProduct } from "@/types";
import { formatNumber, formatSAR } from "@/utils/format";

interface TopProductsProps {
  products: TopProduct[];
}

export default function TopProducts({ products }: TopProductsProps) {
  const max = Math.max(...products.map((product) => product.revenue), 1);

  return (
    <SectionCard
      title="المنتجات الأكثر مبيعًا"
      subtitle="مرتبة حسب الإيرادات"
      icon="ri-fire-line"
      iconClass="bg-accent-100 text-accent-800"
    >
      <ul className="space-y-4">
        {products.map((product, index) => (
          <li key={product.name}>
            <div className="flex items-center justify-between gap-3">
              <div className="flex items-center gap-3 min-w-0">
                <span
                  className={`w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold shrink-0 ${
                    index === 0
                      ? "bg-accent-500 text-foreground-950"
                      : "bg-background-100 text-foreground-600"
                  }`}
                >
                  {index + 1}
                </span>
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-foreground-900 truncate">
                    {product.name}
                  </p>
                  <p className="text-xs text-foreground-500">
                    {formatNumber(product.sold)} طلب
                  </p>
                </div>
              </div>
              <span className="text-sm font-bold text-primary-700 whitespace-nowrap">
                {formatSAR(product.revenue)}
              </span>
            </div>
            <div className="mt-2 h-1.5 rounded-full bg-background-100 overflow-hidden">
              <div
                className="h-full rounded-full bg-primary-500"
                style={{ width: `${(product.revenue / max) * 100}%` }}
              ></div>
            </div>
          </li>
        ))}
      </ul>
    </SectionCard>
  );
}